/**
 * Early Access Signup Form
 * Multi-step form with conditional fields for customer and children data
 */

(function() {
  'use strict';

  // State
  let currentStep = 1;
  const formData = {
    email: '',
    firstName: '',
    lastName: '',
    hasChildren: false,
    children: [],
    phone: '',
    smsConsent: false,
    preferences: [],
    privacyConsent: false
  };

  // DOM Elements
  let modal, overlay, closeBtn, form;
  let steps = {};
  let progressSteps = [];

  // Initialize when DOM is ready
  document.addEventListener('DOMContentLoaded', init);

  function init() {
    // Get modal elements
    modal = document.getElementById('early-access-modal');
    if (!modal) return;

    overlay = document.getElementById('ea-modal-overlay');
    closeBtn = document.getElementById('ea-modal-close');
    form = document.getElementById('ea-signup-form');

    // Get all steps
    document.querySelectorAll('.ea-step').forEach(step => {
      const stepNum = step.dataset.step;
      steps[stepNum] = step;
    });

    // Get progress indicators
    progressSteps = document.querySelectorAll('.ea-progress-step');

    // Bind events
    bindEvents();
  }

  function bindEvents() {
    // Close modal
    if (overlay) overlay.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    // Navigation buttons
    const next1 = document.getElementById('ea-next-1');
    const next2 = document.getElementById('ea-next-2');
    const back2 = document.getElementById('ea-back-2');
    const back3 = document.getElementById('ea-back-3');
    const submitBtn = document.getElementById('ea-submit');
    const closeSuccess = document.getElementById('ea-close-success');
    const tryAgain = document.getElementById('ea-try-again');

    if (next1) next1.addEventListener('click', () => validateAndNext(1));
    if (next2) next2.addEventListener('click', () => validateAndNext(2));
    if (back2) back2.addEventListener('click', () => goToStep(1));
    if (back3) back3.addEventListener('click', () => goToStep(2));
    if (closeSuccess) closeSuccess.addEventListener('click', closeModal);
    if (tryAgain) tryAgain.addEventListener('click', () => goToStep(1));

    // Form submission
    if (form) form.addEventListener('submit', handleSubmit);

    // Children toggle
    const yesBtn = document.getElementById('ea-has-children-yes');
    const noBtn = document.getElementById('ea-has-children-no');
    if (yesBtn) yesBtn.addEventListener('click', () => toggleChildren(true));
    if (noBtn) noBtn.addEventListener('click', () => toggleChildren(false));

    // Child count change
    const childCount = document.getElementById('ea-childCount');
    if (childCount) childCount.addEventListener('change', updateChildFields);

    // Real-time validation
    const emailInput = document.getElementById('ea-email');
    const firstNameInput = document.getElementById('ea-firstName');
    if (emailInput) emailInput.addEventListener('blur', () => validateField('email'));
    if (firstNameInput) firstNameInput.addEventListener('blur', () => validateField('firstName'));

    // Escape key to close
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        closeModal();
      }
    });
  }

  function closeModal() {
    modal.style.display = 'none';
    if (overlay) {
      overlay.style.display = 'none';
    }
    document.body.style.overflow = '';
    // Reset to step 1 after a delay
    setTimeout(() => {
      goToStep(1);
    }, 300);
  }

  function goToStep(step) {
    // Hide current step
    Object.values(steps).forEach(s => s.style.display = 'none');

    // Show target step
    if (steps[step]) {
      steps[step].style.display = 'block';
    }

    // Update progress indicators
    progressSteps.forEach(ps => {
      const psStep = parseInt(ps.dataset.step);
      ps.classList.remove('active', 'completed');
      if (psStep === step) {
        ps.classList.add('active');
      } else if (psStep < step) {
        ps.classList.add('completed');
      }
    });

    currentStep = step;
  }

  function validateAndNext(fromStep) {
    if (fromStep === 1) {
      const isValid = validateStep1();
      if (isValid) {
        collectStep1Data();
        goToStep(2);
      }
    } else if (fromStep === 2) {
      collectStep2Data();
      goToStep(3);
    }
  }

  function validateStep1() {
    let isValid = true;

    // Validate email
    const email = document.getElementById('ea-email');
    const emailError = document.getElementById('ea-email-error');
    if (!email.value || !isValidEmail(email.value)) {
      email.classList.add('error');
      emailError.textContent = 'Please enter a valid email address';
      isValid = false;
    } else {
      email.classList.remove('error');
      emailError.textContent = '';
    }

    // Validate first name
    const firstName = document.getElementById('ea-firstName');
    const firstNameError = document.getElementById('ea-firstName-error');
    if (!firstName.value.trim()) {
      firstName.classList.add('error');
      firstNameError.textContent = 'Please enter your first name';
      isValid = false;
    } else {
      firstName.classList.remove('error');
      firstNameError.textContent = '';
    }

    return isValid;
  }

  function validateField(field) {
    if (field === 'email') {
      const email = document.getElementById('ea-email');
      const emailError = document.getElementById('ea-email-error');
      if (email.value && !isValidEmail(email.value)) {
        email.classList.add('error');
        emailError.textContent = 'Please enter a valid email address';
      } else {
        email.classList.remove('error');
        emailError.textContent = '';
      }
    } else if (field === 'firstName') {
      const firstName = document.getElementById('ea-firstName');
      const firstNameError = document.getElementById('ea-firstName-error');
      if (firstName.value && !firstName.value.trim()) {
        firstName.classList.add('error');
        firstNameError.textContent = 'Please enter your first name';
      } else {
        firstName.classList.remove('error');
        firstNameError.textContent = '';
      }
    }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function collectStep1Data() {
    formData.email = document.getElementById('ea-email').value.trim();
    formData.firstName = document.getElementById('ea-firstName').value.trim();
    formData.lastName = document.getElementById('ea-lastName').value.trim();
  }

  function toggleChildren(hasChildren) {
    const yesBtn = document.getElementById('ea-has-children-yes');
    const noBtn = document.getElementById('ea-has-children-no');
    const section = document.getElementById('ea-children-section');
    const hiddenInput = document.getElementById('ea-hasChildren');

    yesBtn.classList.toggle('active', hasChildren);
    noBtn.classList.toggle('active', !hasChildren);
    hiddenInput.value = hasChildren ? 'yes' : 'no';

    formData.hasChildren = hasChildren;

    if (hasChildren) {
      section.style.display = 'block';
    } else {
      section.style.display = 'none';
      formData.children = [];
      document.getElementById('ea-children-fields').innerHTML = '';
      document.getElementById('ea-childCount').value = '';
    }
  }

  function updateChildFields() {
    const count = parseInt(document.getElementById('ea-childCount').value) || 0;
    const container = document.getElementById('ea-children-fields');
    container.innerHTML = '';

    const actualCount = Math.min(count, 5); // Cap at 5 for UI

    for (let i = 1; i <= actualCount; i++) {
      const fieldHtml = `
        <div class="ea-child-fields">
          <h4>Child ${i}</h4>
          <div class="ea-child-row">
            <div class="ea-form-group">
              <label for="ea-child-${i}-name">Name</label>
              <input type="text" id="ea-child-${i}-name" name="child_${i}_name" placeholder="Child's name">
            </div>
            <div class="ea-form-group">
              <label for="ea-child-${i}-dob">Date of Birth</label>
              <input type="date" id="ea-child-${i}-dob" name="child_${i}_dob" max="${new Date().toISOString().split('T')[0]}">
            </div>
          </div>
        </div>
      `;
      container.insertAdjacentHTML('beforeend', fieldHtml);
    }
  }

  function collectStep2Data() {
    // Collect children data
    formData.children = [];
    const count = parseInt(document.getElementById('ea-childCount').value) || 0;
    const actualCount = Math.min(count, 5);

    for (let i = 1; i <= actualCount; i++) {
      const nameInput = document.getElementById(`ea-child-${i}-name`);
      const dobInput = document.getElementById(`ea-child-${i}-dob`);

      if (nameInput && dobInput && nameInput.value.trim()) {
        formData.children.push({
          name: nameInput.value.trim(),
          dateOfBirth: dobInput.value || null
        });
      }
    }

    // Phone and SMS consent
    formData.phone = document.getElementById('ea-phone').value.trim();
    formData.smsConsent = document.getElementById('ea-smsConsent').checked;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    // Validate privacy consent
    const privacyConsent = document.getElementById('ea-privacyConsent');
    const privacyError = document.getElementById('ea-privacyConsent-error');

    if (!privacyConsent.checked) {
      privacyError.textContent = 'Please accept the privacy policy to continue';
      return;
    }
    privacyError.textContent = '';

    // Collect preferences
    formData.preferences = [];
    document.querySelectorAll('input[name="preferences"]:checked').forEach(cb => {
      formData.preferences.push(cb.value);
    });
    formData.privacyConsent = true;

    // Show loading state
    const submitBtn = document.getElementById('ea-submit');
    const btnText = submitBtn.querySelector('.ea-btn-text');
    const btnLoading = submitBtn.querySelector('.ea-btn-loading');
    submitBtn.disabled = true;
    btnText.style.display = 'none';
    btnLoading.style.display = 'flex';

    try {
      const response = await submitToApi();

      if (response.success) {
        goToStep('success');
      } else {
        showError(response.error || 'Something went wrong. Please try again.');
      }
    } catch (error) {
      console.error('Signup error:', error);
      showError('Network error. Please check your connection and try again.');
    } finally {
      submitBtn.disabled = false;
      btnText.style.display = 'inline';
      btnLoading.style.display = 'none';
    }
  }

  async function submitToApi() {
    // Build payload
    const payload = {
      email: formData.email,
      firstName: formData.firstName,
      lastName: formData.lastName || undefined,
      phone: formData.phone || undefined,
      smsConsent: formData.smsConsent,
      emailConsent: true,
      children: formData.children.length > 0 ? formData.children : undefined,
      preferences: formData.preferences.length > 0 ? formData.preferences : undefined,
      signupSource: 'closed_season_hero',
      utm_source: getUrlParam('utm_source'),
      utm_medium: getUrlParam('utm_medium'),
      utm_campaign: getUrlParam('utm_campaign')
    };

    // Remove undefined values
    Object.keys(payload).forEach(key => {
      if (payload[key] === undefined) {
        delete payload[key];
      }
    });

    const response = await fetch('/apps/full-story/signup', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    return response.json();
  }

  function showError(message) {
    const errorMessage = document.getElementById('ea-error-message');
    if (errorMessage) {
      errorMessage.textContent = message;
    }
    goToStep('error');
  }

  function getUrlParam(param) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param) || undefined;
  }

  // Expose functions for external triggers
  window.EarlyAccessModal = {
    open: function() {
      if (modal) {
        // Always reset to step 1 when opening to ensure consistent state
        goToStep(1);
        modal.style.display = 'flex';
        if (overlay) {
          overlay.style.display = 'block';
        }
        document.body.style.overflow = 'hidden';
      }
    },
    close: closeModal
  };
})();
